module.exports = __webpack_public_path__ + "media/assets/Google_Classroom_Logo-a477848fb6b232353c1b9af04b3ab9c1.svg";